var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-5 d-block d-md-none"},[_c('a',{staticClass:"history-back",attrs:{"href":_vm.link}},[_vm._v("Вернуться")])])
}
var staticRenderFns = []

export { render, staticRenderFns }